module.exports = __webpack_public_path__ + "img/安徽省老龄信息管理系统.57b53882.jpg";